module.exports = __webpack_public_path__ + "static/media/depression_mild.be9439f7.svg";